import 'dotenv/config'
import Vue from 'vue'
import VueImg from 'v-img'
import App from './App.vue'
import router from './router'
import store from './store/store'
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm'
import VueSocketIOExt from 'vue-socket.io-extended'
import VueLazyload from 'vue-lazyload'
import { Manager } from 'socket.io-client'
import SweetModal from 'sweet-modal-vue/src/plugin.js'
import Multiselect from 'vue-multiselect'
import linkify from 'vue-linkify'
import vSelect from 'vue-select'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
// Import the styles directly. (Or you could add them via script tags.)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import 'vue-select/dist/vue-select.css'

import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import settingAxios from '@/helpers/axiosHelpers'
require('dotenv').config()
require('./filters')

Vue.component('multiselect', Multiselect)
Vue.component('v-select', vSelect)
Vue.component('paginate', Paginate)

// Google Maps logic
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDtPvCf3Zm24yJP2_-n4VeAK7eP3caZcuI',
    libraries: 'places'
  }
})

Vue.directive('linkified', linkify)

let socketUrl = process.env.VUE_APP_SOCKET_URL || 'https://beneat-socketio.beneat-chat.com'
let url = process.env.VUE_APP_API_URL || 'https://api.beneat-chat.com'
let socketTransports

if (window.location.hostname === 'localhost' && process.env.NODE_ENV !== 'production') {
  url = process.env.VUE_APP_API_URL || 'http://localhost:3000'
  socketUrl = process.env.VUE_APP_SOCKET_URL || 'http://localhost:5900'
  if (process.env.VUE_APP_SOCKET_URL) {
    // Remote socket server: its CORS list rejects localhost and it refuses
    // direct websocket upgrades, so go through the dev-server proxy
    // (vue.config.js) with polling only.
    // VUE_APP_SOCKET_TRANSPORTS=polling,websocket lets the upgrade through the
    // proxy, to reproduce what production browsers actually do.
    socketUrl = window.location.origin
    socketTransports = (process.env.VUE_APP_SOCKET_TRANSPORTS || 'polling').split(',').map(s => s.trim()).filter(Boolean)
  }
}
// if (window.location.hostname === '167.99.30.138') {
//   url = 'http://167.99.30.138:3000'
// }

const manager = new Manager(socketUrl, {
  ...(socketTransports && { transports: socketTransports }),
  reconnectionDelayMax: 10000
})

const socket = manager.socket('/client', {
  reconnect: true,
  auth: {
    token: process.env.VUE_APP_SOCKETIO_CHAT_CLIENT_TOKEN
  }
})

manager.open((err) => {
  if (err) {
    console.error('socket error', err)
    // an error has occurred
  } else {
    console.log('WSs connected to server')
    // the connection was successfully established
  }
})

// const socket = io(url)
Vue.use(VueSocketIOExt, socket)
Vue.use(BootstrapVue)

const unknownImage = require('../public/images/unknown.png')
Vue.use(VueLazyload, {
  error: unknownImage,
  adapter: {
    error (listender, Init) {
      // console.log('errorrrrr')
    }
  }
})
Vue.use(VuePlyr)
Vue.use(VueImg)
Vue.use(VueSweetalert2)
Vue.use(SweetModal)

Vue.config.productionTip = false

Vue.prototype.$apiUrl = url

settingAxios(axios, url)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
